import { render, staticRenderFns } from "./Oss.vue?vue&type=template&id=3874d990&scoped=true&"
import script from "./Oss.vue?vue&type=script&lang=js&"
export * from "./Oss.vue?vue&type=script&lang=js&"
import style0 from "./Oss.vue?vue&type=style&index=0&id=3874d990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3874d990",
  null
  
)

export default component.exports